class Footer {
    constructor() {
        this.url = '/wp-admin/admin-ajax.php';
        this.button = document.querySelector('.footer__info__form-button');
        this.responseSection = document.querySelector('.footer__info__form-response');

        this.init()
    }

    init() {
        if (this.button) {
            this.button.addEventListener('click', (event) => {
                this.ajaxSendEmail()
            })
        }
    }

    async ajaxSendEmail() {
        let email = document.querySelector('.footer__info__form-input');
        const response = await fetch(this.url, {
            method: 'POST',
            body: new URLSearchParams({
                action: 'footerSubscription',
                email: email.value,
            })
        });
        const resp = await response.json();
        if (resp.success === true) {
            this.responseSection.classList.remove('error')
            this.responseSection.classList.add('success')
            this.responseSection.textContent = resp.message
        } else {
            this.responseSection.classList.remove('success')
            this.responseSection.classList.add('error')
            this.responseSection.textContent = resp.message
        }
        email.value = '';
    }
}

new Footer();